import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent, NodeType } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-one-download',
    templateUrl: './one-download.component.html',
    standalone: false,
})
export class OneDownloadComponent extends BlockAbstractComponent implements OnInit {
    node!: NodeType;

    override ngOnInit() {
        super.ngOnInit();
        if (this.block.nodes && this.block.nodes.length > 0) {
            this.node = this.block.nodes[0];
            this.block.data.documentId = this.parser.getDownloadURL(this.node.token);
        } else if (this.block.data.documentId) {
            this.block.data.documentId = this.parser.parseContent(this.block.data.documentId);
        }

        if (this.block.data.buttonLink.length > 0) {
            this.block.data.documentId = '';
        }
    }

    getDownloadUrl(): string {
        const url = this.block.data.buttonLink || 'https://onepage.builtoncore.com' + this.block.data.documentId;
        return url.startsWith('https://') || url.startsWith('http://') ? url : '/' + url;
    }
}
